import React from "react";
import {ToastContainer} from "react-toastr";

let container

/**
 * @param {string} text
 * @param {string} title
 * @param {string} type
 */
export const flash = (text, title, type = 'success') => {
	if (type === 'success') {
		container.success(
			text,
			title,
			{
				closeButton: false
			}
		);
	} else if (type === 'error') {
		container.error(
			text,
			title,
			{
				closeButton: false
			}
		);
	} else if (type === 'warning') {
		container.warning(
			text,
			title,
			{
				// We make it very long because if we set to 0 the clear() function
				// will never remove the message from the stack.
				timeOut: 100000,
				closeButton: true
			}
		);
	}
}

export const clearFlash = () => {
	container.clear()
}

export const  FlashMessage = () => {

	return (
		<ToastContainer
			ref={ref => container = ref}
			className="toast-top-right"
		/>
	)
}
